<template>
  <div>
  <div class="left">
    <div class="muln">
      <div class="lefts" @click="turnServe()">
        <i class="el-icon-thumb"></i>
        <a>技术服务</a>
      </div>
    </div>
    <div class="muln">
      <div class="lefts" @click="()=>{this.$router.push('/tryOut')}">
        <i class="el-icon-goods"></i>
        <a>试用申请</a>
      </div>
    </div>
    <!-- <div class="muln">
      <div class="lefts" @click="randomQQ">
        <img class="img" src="../../../images/qq.png" alt="" />
        <a href="">客服咨询</a>
        <a target="_blank" class="getUrl" href="tencent://message/?uin=2834338941&Site=qq&Menu=yes" id="contactQQ">客服咨询</a>
      </div>
    </div> -->
    <div class="consult">
      <div class="right" v-if="openone">
        <div class="openones"><a>400-088-0777</a></div>
      </div>
      <div class="lefts" @click="changephone">
        <img class="img" src="../../../images/dianhua.png" alt="" />
        <a href="javascript:;">热线咨询</a>
      </div>
    </div>
    <div class="wechat">
      <div class="rights" v-if="openthree">
        <div class="openthrees">
          <img class="wexin" src="../../../images/1.jpg" alt="" />
        </div>
      </div>
      <div class="lefts" @click="changewechat">
        <img class="img" src="../../../images/weixin.png" alt="" />
        <a href="javascript:;">公众号</a>
      </div>
    </div>
    <div class="eamil">
      <div class="right" v-if="opentwo">
        <div class="opentwos"><a>service_me@bioleaper.com</a></div>
      </div>
      <div class="lefts" @click="changeeamil">
        <img class="img" src="../../../images/youxiang.png" alt="" />
        <a href="javascript:;">联系邮箱</a>
      </div>
    </div>
  </div>   
  <el-dialog title="技术服务" :visible.sync="dialogFormVisible" width="800px">
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="姓名" prop="name">
          <el-input placeholder="请输入姓名" v-model="ruleForm.name"></el-input>
        </el-form-item>
        <el-form-item label="联系方式" prop="contact">
          <el-input placeholder="请输入联系方式" v-model="ruleForm.contact"></el-input>
        </el-form-item>
        <el-form-item label="学校课题组">
          <el-input  placeholder="请输入学校课题组" type="textarea" v-model="ruleForm.group"></el-input>
        </el-form-item>
        <el-form-item label="实验需求" prop="demand">
          <el-input  placeholder="请输入实验需求" type="textarea" v-model="ruleForm.demand"></el-input>
        </el-form-item>
        <el-form-item label="预期效果">
          <el-input  placeholder="请输入预期效果" type="textarea" v-model="ruleForm.effect"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('ruleForm')"  :loading="isloadding">确 定</el-button>
      </div>
    </el-dialog>
</div>
</template>

<script>
export default {
  data() {
    return {
      openone: false,
      opentwo: false,
      openthree: false,
      dialogFormVisible:false,
      isloadding:false,
      ruleForm:{
        name:'',
        contact:'',
        group:'',
        demand:'',
        effect:''
      },
      rules: {
          name: [
            { required: true, message: '请输入姓名', trigger: 'blur' }
          ],
          contact: [
            { required: true, message: '请选择联系方式', trigger: 'blur' }
          ],
          demand: [
            { required: true, message: '请选择实验需求', trigger: 'blur' }
          ]
        }
    };
  },
  methods: {
    turnServe(){
     this.dialogFormVisible = true
     this.ruleForm.name = ''
     this.ruleForm.contact = ''
     this.ruleForm.group = ''
     this.ruleForm.demand = ''
     this.ruleForm.effect = ''
    },
    randomQQ(){
      // var QQData = ['2834338941','2646414277']
      // var QQRandom = Math.floor(Math.random()*QQData.length)
      // var src =  "tencent://message/?uin="+QQData[QQRandom]+"&Site=&menu=yes"
      // document.querySelector('#contactQQ').href=src
    },
    changephone() {
      this.openone = !this.openone;
      this.opentwo = false;
      this.openthree = false;
    },
    changeeamil() {
      this.opentwo = !this.opentwo;
      this.openthree = false;
      this.openone = false;
    },
    changewechat() {
      this.openthree = !this.openthree;
      this.opentwo = false;
      this.openone = false;
    },
    submitForm(formName){
      this.$refs[formName].validate((valid) => {
          if (valid) {
            this.isloadding = true
            this.$api.homepage.technicalservice(this.ruleForm).then((res)=>{ 
              this.isloadding = false
              if(res.status == 1){
                this.$message.success('已提交成功,请等待后续反馈')
                this.dialogFormVisible = false
              }
            })
          } else {
            return false;
          }
        });
    }
  },
};
</script>

<style>
.v-modal{
  z-index:2 !important;
}
</style>

<style lang="less" scoped> 
.left {
  .consult,
  .eamil,
  .wechat,
  .muln {
    width: 260px;
    height: 56px;
    border-radius: 1px 0px 0px 1px;
    position: relative;
    .lefts {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      margin: 3px;
      width: 76px !important;
      height: 56px;
      background: #003871;
      border-radius: 2px 0px 0px 2px;
      i{
        font-size:22px;
        color:#c7d3e0
      }
      .img {
        width: 22px;
        height: 22px;
      }
      a {
        font-size: 13px;
        text-align: left;
        color: #ffbb00;
        text-align: center;
        line-height: 16px;
      }
    }
    .rights {
      width: 172px;
      height: 157px;
      position: absolute;
      left: -147px;
      top: -30px;
      border-radius: 1px;
      .wexin {
        width: 124px;
        height: 124px;
      }
    }
    .right {
      min-width: 204px;
      height: 56px;
      background: #003871;
      position: absolute;
      right:260px;
      border-radius: 1px;
      display: flex;
      align-items: center;
      justify-content: center;
      .openones,
      .opentwos,
      .openthrees {
        a {
          font-size: 22px;
          color: #ffbb00;
          margin: 10px 15px;
        }
      }
    }
  }
}
</style>